/**
 * Return the Apex probe kind that the given solution's dosing effect measures,
 * so the DoseCalculator can prefill "Current Level" from live readings.
 */
export function probeKindForSolution(solution) {
    const name = solution.name.toLowerCase();
    // pH must be checked before dKH — Sodium Hydroxide is both.
    if (name.includes('sodium hydroxide') || name.includes(' ph') || name.includes('(ph)')) {
        return 'ph';
    }
    const units = solution.units;
    // Alkalinity: any unit matching dKH (after pH exclusion above)
    if (units === 'dKH')
        return 'alk';
    // Calcium: ppm is shared by many, so we narrow by name hint
    if (units === 'ppm') {
        if (name.includes('calcium'))
            return 'ca';
        if (name.includes('magnesium'))
            return 'mg';
    }
    return null;
}
/**
 * Convert a probe value from whatever Apex returns to a comparable number.
 *
 * Fahrenheit → dKH or pH units are obviously not convertible; this just
 * rounds the raw number for display. Callers should sanity-check the
 * probe unit before using.
 */
export function normaliseProbeValue(value) {
    return Math.round(value * 100) / 100;
}
//# sourceMappingURL=apex-mapping.js.map